import { gql } from '@apollo/client';

export const DOWNLOAD_PERFORMANCE_REPORTS = gql`
  query downloadPerformanceReports($lineItems: [String!]!, $dimensionList: [Dimensions]!, $campaignId: ID!) {
    downloadPerformanceReports(lineItems: $lineItems, dimensionList: $dimensionList, campaignId: $campaignId)
  }
`;
